import { BlogSection } from "@/types/blog";

export const anmerkung: BlogSection = {
  id: "anmerkung",
  title: "Anmerkung",
  content: `
    <p>Wenn Sie Führung nicht nur organisatorisch, sondern als innere Haltung weiterentwickeln möchten, begleite ich Sie gern.</p>

    <p>Manchmal geht es dabei um persönliche Klarheit.<br/>
    Manchmal um kulturelle oder strukturelle Fragen im Unternehmen.<br/>
    Oft um beides.</p>

    <p>Ich arbeite mit Einzelpersonen und Organisationen an genau diesen Übergängen: zwischen Verstand und Empathie, Entscheidungskraft und Beziehung, Strategie und Menschlichkeit.</p>

    <p>Weitere Informationen finden Sie auf meiner <a href="/" class="text-primary hover:underline">Website</a>.</p>
  `
};
